// extracted by mini-css-extract-plugin
export default {"lineButtons":"otherPropertyItemNew_lineButtons__4mo6f","headers":"otherPropertyItemNew_headers__awiDP","semiTitle":"otherPropertyItemNew_semiTitle__-LzRA"};